<template>
   <a  v-if="isImage(attach.name)"
      data-bs-toggle="offcanvas"
      href="#offcanvasAttView"
      role="button"
      aria-controls="offcanvasAttView"
      :data-cell-id="cell_id"
      :data-attach-id="attach.id"
      :data-attach-name="attach.name"
      :data-attach-putOff="putOff.toString()"
      :data-board-id="board_id"
      class="text-decoration-none"
   >
      <div  v-if="extension(attach.name).toUpperCase()=='PDF'"
      class="img-attach rounded text-center tc-gray p-4">
         <b>{{extension(attach.name)}}</b>
      </div>
      <!--
      <img v-else
         :src="`/WorkSpace/Content/Attach/${attach.id}_${attach.name}`" 
         class="col img-attach rounded" 
         alt=""
      >
      -->
      <img v-else
         :src="attachFolder+encodeURIComponent(`${attach.id}_${attach.name}`)" 
         class="col img-attach rounded" 
         alt=""
      >
   </a>
   <div v-else class="img-attach rounded text-center tc-gray p-4">
      <b>{{extension(attach.name)}}</b>
   </div>
</template>

<script>
export default {
   props: {
      attach: {
         type: Object,
         required: true
      },
      cell_id: {
         type: Number,
         required: true
      },
      putOff: {
         type: Boolean,
         required: true
      },
      board_id: {
         type: Number,
         required: true
      },
   },

   setup() {

      const attachFolder = process.env.VUE_APP_BASE_CNTT_ATT_FOLDER

      function extension(fileName) {
         let exten = fileName.lastIndexOf(".");
         if (exten == -1) {
            return ""; // empty extension
         }
         return fileName.substring(exten+1);
      }

      function isImage (fileName) {
         let imageFileExten = ".pdf.jpg.apng.avif.gif.jpeg.jfif.pjpeg.pjp.png.svg.webp.bmp.ico.cur.tif.tiff."
         if (imageFileExten.lastIndexOf(extension(fileName.toLowerCase())) > 0) {
            return true
         }
         return false
      }

      return {
         //lbClass, lbResume
         extension, isImage, attachFolder
      }
   }
}
</script>

<style scoped>
.img-attach {
   height: 82px;
   width: 112px;
   background-color: #e5e7e9;
}
.tc-gray {
   color: gray;
}
</style>